<template>
  <div id="slideRheostat">
    <div class="container">
      <div class="header">
        <div class="titelbox" v-if="!showMask">
          <div class="titelbox-ico" @click="tohome" bucaiji="true">
            <van-icon name="arrow-left" />
          </div>
          <div class="titelbox-tm">
            <span class="nub">{{ swipeIndex + 1 }}</span>/{{ answerBox.length }}题
          </div>
          <div class="titelbox-tk" @click="onShowMask" name="答题页-题卡" data-sensors-click>
            <img src="../assets/tk.png" alt="" name="答题页-题卡" data-sensors-click />题卡
          </div>
        </div>
        <div class="titelbox" v-if="showMask">
          <div class="titelbox-ico" @click="onShowMasks" bucaiji="true">
            <van-icon name="arrow-left" />
          </div>
          <div class="titelbox-tm">题卡</div>
          <div class="titelbox-tk"></div>
        </div>
      </div>
      <div class="main">
        <div class="uuu" v-if="!showMask">
          <van-swipe @touchmove="touchmove()" :touchable="touchable" indicator-color="white" :initial-swipe="swipeIndex"
            @change="onSwipe" :show-indicators="false" :loop="false" style="height: calc(100vh - 50px)">
            <!-- style="height: calc(100vh - 50px);" -->
            <van-swipe-item :initial-swipe="swipeItemIndex" v-for="(item, index) in answerBox" :key="index">
              <div class="kmj">
                <div class="questiontypes">
                  {{ item.Style }}
                  <span v-for="(items, index) in quantitydata" :key="index" v-if="items.Style == item.Style">{{
                    item.indexs }}/{{ items.quantity }}</span>
                </div>
                <div class="answer">
                  <div class="answer-top">
                    <div class="answer-title">
                      <span ref="content" class="imageEnlargement" @click="imageEnlargement" v-html="item.Title">
                      </span>
                      <!-- 	{{ item.FrontTitle }}
											{{ item.Title }} -->
                    </div>
                  </div>
                </div>
                <div class="answer-box">
                  <ul>
                    <!-- v-if="items.StyleType=='ATEST'  || items.SubType=='单项' || items.StyleType!='XTEST'|| item.SubType!='不定项'" -->
                    <div class="van-radio-group" v-if="
                      item.Type == 'ATEST' ||
                      (item.Type == 'BTEST' && item.SubType == '') ||
                      (item.Type == 'BTEST' && item.SubType == '单项') ||
                      (item.Type == 'A3TEST' && item.SubType == '单项') ||
                      (item.Type == 'A3TEST' && item.SubType == '')
                    ">
                      <div v-for="(Selected, SelectedIndex) in item.SelectedItems" class="checkedBox van-radio"
                        :key="SelectedIndex" bucaiji="true" @click="
                          onAnswer(
                            index,
                            Selected.ItemName,
                            Selected.Content,
                            SelectedIndex,
                            item.Type
                          )
                          " checked-color="#ffb300">
                        <div>
                          <div class="yqbox">
                            <div class="checkedBox-left" :class="Selected.open ? 'pitch' : ''" bucaiji="true">
                              {{ Selected.ItemName }}
                            </div>
                          </div>
                        </div>
                        <div class="checkedBox-right" :class="Selected.open ? 'pitchs' : ''">
                          <span ref="content" v-html="Selected.Content" bucaiji="true">
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- 1.ATEST-单选
							2.XTEST-多选
							3.BTEST：如果SubType为空或为单项，则单选；如果SubType为多项则是多选; 如果SubType为不定项，则可能单选可能多选
							4.A3TEST:如果SubType为空或为单项，则单选；如果SubType为多项则是多选; 如果SubType为不定项，则可能单选可能多选 -->

                    <div v-if="
                      item.Type == 'XTEST' ||
                      (item.Type == 'BTEST' && item.SubType == '多项') ||
                      (item.Type == 'BTEST' && item.SubType == '不定项') ||
                      (item.Type == 'A3TEST' && item.SubType == '多项') ||
                      (item.Type == 'A3TEST' && item.SubType == '不定项') ||
                      (item.Type == 'A3TEST' && item.SubType == '不定向')
                    ">
                      <!-- -->
                      <div v-for="(Selected, SelectedIndex) in item.SelectedItems" class="checkedBox van-radio"
                        :key="SelectedIndex" bucaiji="true" @click="
                          onCheckboxAnswer(
                            index,
                            Selected.ItemName,
                            SelectedIndex
                          )
                          " checked-color="#ffb300">
                        <div>
                          <div class="checkedBox-leftb" :class="Selected.open ? 'pitch' : ''" bucaiji="true">
                            {{ Selected.ItemName }}
                          </div>
                        </div>
                        <div class="checkedBox-right" :class="Selected.open ? 'pitchs' : ''">
                          <span ref="content" v-html="Selected.Content" bucaiji="true"></span>
                        </div>
                      </div>
                    </div>
                    <div class="van-radio-group" v-if="item.Type == 'PDTEST'">
                      <div v-for="(Selected, SelectedIndex) in item.SelectedItems" class="checkedBox van-radio"
                        :class="Selected.open ? 'pitch' : ''" :key="SelectedIndex" bucaiji="true" @click="
                          onAnswer(
                            index,
                            Selected.ItemName,
                            Selected.Content,
                            SelectedIndex,
                            item.Type
                          )
                          " checked-color="#ffb300">
                        <div>
                          <div class="yqbox">
                            <div class="checkedBox-left" :class="Selected.open ? 'pitch' : ''" bucaiji="true">
                              {{ Selected.ItemName }}
                            </div>
                          </div>
                        </div>
                        <div class="checkedBox-right">
                          <span ref="content" v-html="Selected.Content" bucaiji="true"></span>
                        </div>
                      </div>
                    </div>
                    <!-- 简答题 -->
                    <div class="textareas-box" v-if="item.StyleType == 'JDTEST'">
                      <van-field class="textareas" v-model="messageDa[index]" rows="1" autosize type="textarea"
                        placeholder="请填写正确答案" />
                      <div style="color: rgb(153, 153, 153)">
                        本题不支持答题情况判断，可在交卷后核对答案并查看解析
                      </div>
                    </div>
                    <div v-if="item.StyleType == 'JDTEST'" class="tijiao_newbtn-box" style="position: relative">
                      <div @click="onJdabtn(index)" class="tijiao_newbtn" name="提交答案">
                        提交答案
                      </div>
                      <span class="tijiao_newbtn-span" v-show="jdtest[index].index != ''">(已提交)</span>
                    </div>
                  </ul>
                </div>
              </div>
              <div></div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div v-if="showMask">
          <div>
            <div class="NewcardContent">
              <div v-for="(items, indexs) in Styledata" :key="indexs">
                <div class="txdatas">
                  {{ items }}
                  <span class="txzf">{{ typeScore.length != 0 ? typeScore[indexs] : 1 }}分</span>
                </div>
                <ul class="NewcardContent-ul">
                  <li class="NewcardContent-li" v-for="(item, index) in answerBox" @click="onAnswerIndex(index)"
                    :class="topicAnswer[index].ItemName != '' ? 'nowNoan' : ''" :key="index" v-if="item.Style == items"
                    test_ids="true" :test_id="index + 1" element_namesb="true" element_names="题目选择">
                    {{ index + 1 }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="diban" v-if="!showMask && answerBox.length != swipeIndex + 1">
          <van-button round type="info" @click="toptm" v-if="swipeIndex != 0" name="上一题">上一题</van-button>
          <van-button round type="info" @click="btntm" name="下一题">下一题</van-button>
          <!-- <div><van-button round type="info">圆形按钮</van-button></div>
          <div><van-button round type="info">圆形按钮2</van-button></div> -->
        </div>
        <div class="diban" v-if="answerBox.length == swipeIndex + 1 || showMask">
          <van-button round type="info" @click="toptm" v-if="!showMask" name="上一题">上一题</van-button>
          <van-button round type="info" @click="onAnswer_exam" name="交卷">交卷</van-button>
        </div>
      </div>
    </div>
    <van-loading type="spinner" color="#1989fa" vertical class="spinner" v-if="loadingShow">{{ loadingText
    }}</van-loading>
  </div>
</template>

<script>
var that;
var timer = null;
import Vue from "vue";
// import lading from "../../../components/loading.vue";
import {
  Swipe,
  SwipeItem,
  RadioGroup, //单选
  Radio,
  Checkbox, //多选
  CheckboxGroup,
  Dialog, //确定取消弹出框
  CountDown, //倒计时
  Field,
} from "vant";

// Vue.use(Swipe).use(SwipeItem).use(Radio).use(RadioGroup).use(Checkbox);
import { getcs, insertDates } from "../api/api";
import { topicData, setImgUrl } from "../model/topicDispose";
import { mapState } from "vuex";
import store from "@/store";
export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Dialog.Component.name]: Dialog.Component,
    [CountDown.name]: CountDown,
    // lading, //加载
    [Field.name]: Field,
  },
  data() {
    return {
      swipeIndex: 0, //swipe
      swipeItemIndex: 0, //swipeItem
      touchable: true, //是否可以滑动
      answerBox: [], //所有题目
      radio: [], //多选单选值
      group: [], //用来暂时存储多选题目答案，再转换成字符串保存到topicAnswer
      topicAnswerTrue: true, //用来判断储存答案数组是否创建，创建了第二次不在重复创建
      topicAnswer: [], //存储多选单选答案
      multiSelectShow: false, //判断是否显示答案
      simulationTrue: false, //查看答案题目显示颜色
      showMask: false, //题卡
      contrastAnswer: [], //正确答案
      correctAnswer: [],
      haveAnswer: [], //已答题目
      accuracy: "",
      //考试用时
      hour: 0,
      minutes: 0,
      seconds: 0,
      achievementsBox: {}, //传到成绩页面
      loadingShow: true, //加载
      messageDa: [], //简答题
      userID: "", //登录id
      examHistoryID: "",
      jdtest: [], //简答题,
      Styledata: [], //题型
      quantity: [],
      quantitydata: [], //题型的数量
      typeScore: [],
      info: [],
      HowLongTime: 0,
      systemDates: "",
      dataappName: "",
      astrict: false,
      loadingText: "加载中...",
    };
  },
  computed: {
    ...mapState(["guid"]),
    ...mapState(["userInfo"]),
    ...mapState(["configID"]),
    ...mapState(["agentCode"]),
  },

  async created() {
    // window.document.title = "答题-题目详情";
    this.typeScore = JSON.parse(localStorage.getItem("typeScore"));
    var nowDate = new Date();
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      getHours: nowDate.getHours(),
      getMinutes: nowDate.getMinutes(),
      getSeconds: nowDate.getSeconds(),
    };
    var getMinutes;
    if (date.getMinutes > 9) {
      getMinutes = date.getMinutes;
    } else {
      getMinutes = "0" + date.getMinutes;
    }
    let systemDates = `${date.year}-${date.month}-${date.date} ${date.getHours}:${getMinutes}:${date.getSeconds}`;
    this.systemDates = systemDates;
  },
  async mounted() {
    that = this;
    await store.dispatch("configID", {});
    that.freeQuestionBankData();
    this.info = localStorage.getItem("info");
    localStorage.setItem("Status", 0); //未交卷
    clearInterval(timer);
    timer = setInterval(that.onHowLongTime, 1000);
    if (this.$route.query.onShowMasks) {
      that.showMask = true;
      that.answerContrast();
    }
  },

  //当离开页面时，清除倒计时
  beforeDestroy() {
    clearInterval(timer);
  },
  //当离开页面时，清除倒计时
  beforeDestroy() {
    clearInterval(timer);
  },
  methods: {
    imageEnlargement(e) {
      if (e.target.nodeName == "IMG") {
        //判断点击富文本内容为img图片
        var str = e.target.src;
        ImagePreview([str]);
      } else {
      }
    },
    //返回首页
    tohome() {
      Dialog.confirm({
        title: " 确认要退出答题吗？",
        message: "退出后我们会保留 您的当前进度",
        confirmButtonColor: "#65b2ff",
        className: "className",
      })
        .then(() => {
          clearInterval(timer);
          localStorage.setItem(
            "wjjachievementsBox",
            JSON.stringify(that.answerBox)
          );
          localStorage.setItem(
            "wjjtopicAnswer",
            JSON.stringify(that.topicAnswer)
          );
          localStorage.setItem("datanames", this.dataappName);
          that.onIfon(0); //提交答题信息
          localStorage.setItem("Status", 0); //未交卷
          that.$router.push({
            path: "/home",
            query: {
              configID: this.configID,
              agentCode: this.agentCode,
            },
          });
        })
        .catch(() => { });
    },
    //上一题
    toptm() {
      if (this.swipeIndex == 0) {
        this.$toast("当前题目第一题");
        return;
      }
      this.swipeIndex--;
      this.swipeItemIndex--;
      that.group = [];
      if (that.topicAnswer[that.swipeIndex].group) {
        that.group = that.topicAnswer[that.swipeIndex].group;
      }
    },
    //下一题
    btntm() {
      if (this.swipeIndex + 1 == this.answerBox.length) {
        this.$toast("没有题目了");
        return;
      }
      this.swipeIndex++;
      this.swipeItemIndex++;
      that.group = [];
      if (that.topicAnswer[that.swipeIndex].group) {
        that.group = that.topicAnswer[that.swipeIndex].group;
      }
    },
    //简答题提交.
    onJdabtn: function (index) {
      if (that.messageDa[that.swipeItemIndex] == undefined) {
        that.$toast("请填写答案");
        return;
      }
      that.topicAnswer[that.swipeIndex]["index"] = index;
      that.topicAnswer[that.swipeIndex]["ItemName"] = that.messageDa[index];
      that.jdtest[that.swipeItemIndex].index = "show"; //判断是否显示简答题
      that.$toast("提交成功");
    },

    //交卷
    onAnswer_exam: function () {
      //答题时长
      this.$options.methods.onHowLongTime();
      var addArr = [];
      for (let index = 0; index < that.topicAnswer.length; index++) {
        if (that.topicAnswer[index].ItemName == "") {
          addArr.push(that.topicAnswer[index].ItemName);
        }
      }
      that.answerContrast();
      if (that.haveAnswer.length == 0) {
        this.$toast("请您先答题，再交卷");
        return;
      }

      var title = "";
      if (addArr.length == 0) {
        title = "确定交卷吗？";
      } else {
        title = `还有${addArr.length}题未作答,确认交卷吗？`;
      }
      Dialog.confirm({
        title: title,
        message: "",
        confirmButtonColor: "#65b2ff",
        confirmButtonText: "确认交卷", //改变确认按钮上显示的文字
        cancelButtonText: "取消交卷", //改变取消按钮上显示的文字
      })
        .then(() => {
          if (this.astrict) {
            return;
          }
          this.loadingText = "交卷中,请稍等...";
          this.loadingShow = true;
          this.astrict = true;
          this.$selectInfo = "已交卷";
          localStorage.setItem("topicAnswer", JSON.stringify(this.topicAnswer));
          localStorage.setItem(
            "achievementsBox",
            JSON.stringify(that.achievementsBox)
          );
          localStorage.removeItem("answerLocation");
          that.onIfon(1); //提交答题信息
          localStorage.setItem("Status", 1); //已交卷
          clearInterval(timer);
        })
        .catch(() => {
          // on cancel
          this.astrict = false;
        });
    },
    //查看答题情况
    onIfon(Status) {
      var topicBox = this.answerBox;
      var topicAnswer = this.topicAnswer;
      this.answerContrast();
      var scoreBox = 0;
      var answerInfo = []; //用户选择信息
      topicBox.forEach((item, index) => {
      if (item.Answer == topicAnswer[index].ItemName) {
        scoreBox += parseFloat(item.Score);
      }
      if (topicAnswer[index].ItemName != "") {
          answerInfo.push(topicAnswer[index]);
        }
    });
      console.log('做题页面的考试成绩：' + scoreBox)
      //用户没有选择，不请求接口
      if (answerInfo.length == 0) {
        return;
      }

      localStorage.setItem("HowLongTime", this.HowLongTime);
      let data = {
        config_id: this.configID, // 考试的配置id
        score: scoreBox, // 分数
        time: this.HowLongTime, // 答题时间，秒数
        create_time: this.systemDates, // 开始答题时间
        agentCode: this.agentCode, // 代理商编码
        registryPlatform: "抽题组卷H5", // 平台
        amount: this.haveAnswer.length, // 答题量
        status: Status, // 是否交卷 （1 已交卷 0未交卷）
        info: JSON.stringify(answerInfo), // 答题详情 json 字符串
        accuracy:
          Math.round(
            (this.contrastAnswer.length / this.correctAnswer.length) * 100
          ) /
          1 +
          "%", // 正确率
        ksbguid: this.guid, // 考试宝典guid
      };
      if (sessionStorage.getItem("card_id")) {
        data.card_id = sessionStorage.getItem("card_id");
      }
      insertDates(data).then((res) => {
        if (Status == 0) {
          if (res.data.code == 501) {
          }
          if (res.data.code != "0") {
            this.$toast("做题记录提交失败！");
          }
        } else {
          if (res.data.code == 501) {
            this.logginsBox();
            sessionStorage.setItem("msgLogin", 1);
          }
          if (res.data.code == 0) {
            this.loadingShow = false;

            that.$router.push({
              path: "/achievements",
            });
          } else {
            this.$toast("做题记录提交失败！");
          }
        }
      });
    },

    //题卡
    onHowLongTime() {
      that.HowLongTime += 1;
    },
    onAnswerIndex: function (index) {
      that.swipeItemIndex = index;
      that.swipeIndex = index;
      that.showMask = false;
      that.group = [];
      if (that.topicAnswer[that.swipeIndex].group) {
        that.group = that.topicAnswer[that.swipeIndex].group;
      }
    },
    //多选查看答案
    onExamine: function () {
      that.multiSelectShow = true;
      that.simulationTrue = true;
    },
    onSwipe: function (e) {
      that.swipe = e;
      that.swipeItemIndex = e; //页面位置
      that.swipeIndex = e; //页面位置
      that.group = [];
      if (that.topicAnswer[that.swipeIndex].group) {
        that.group = that.topicAnswer[that.swipeIndex].group;
      }
    },
    onShowMask: function () {
      that.showMask = true;
      that.answerContrast();
    },
    onShowMasks: function () {
      that.showMask = false;
      that.answerContrast();
    },
    //返回
    onArrowsLeft: function () {
      Dialog.confirm({
        title: "考试正在进行中",
        message: "退出考试后不保存答案记录",
        confirmButtonColor: "#65b2ff",
      })
        .then(() => {
          // on confirm
          that.$router.push({
            path: "/simulation",
            query: {},
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    //题卡---返回试题页面
    onFreeQuestionBank: function () {
      that.showMask = false;
    },

    //数据初始化加载
    async freeQuestionBankData() {
      var res = await this._getcs();
      this.dataappName = res.data.data.name;
      if (res.data.status == 201) {
        this.$toast(res.data.msg);
      }

      if (res.status == 200) {
        that.examHistoryID = res.data.data.examHistoryID; //取题接口获取的examHistoryID
        let StyleItems = res.data.data.test.test;
        // let info = res.data.data.info; //记录用户操作
        let answerBox = await topicData(StyleItems);
        if (answerBox.length == 0) {
          this.$toast("获取不到题目数据,请联系管理员!");
        }
        var Styledata = [];

        for (let i in answerBox) {
          var APPEName = res.data.data.test.ImgAppEName; //2022/4/8修改
          Styledata.push(answerBox[i].Style);
          answerBox[i].FrontTitle = answerBox[i].FrontTitle
            ? answerBox[i].FrontTitle
            : "";
          answerBox[i].Title = answerBox[i].FrontTitle + answerBox[i].Title;

          answerBox[i].SelectedItems.forEach((element) => {
            element.Content = setImgUrl(element.Content, APPEName);
          });
          answerBox[i].Title = setImgUrl(answerBox[i].Title, APPEName);
          answerBox[i].Explain = setImgUrl(answerBox[i].Explain, APPEName);
        }
        Styledata = Array.from(new Set(Styledata));
        that.Styledata = Styledata;
        var tx = [];
        var boxarray = [];

        for (let i = 0; i < Styledata.length; i++) {
          var ib = 0;
          var minarray = [];

          for (let j = 0; j < answerBox.length; j++) {
            if (Styledata[i] == answerBox[j].Style) {
              ib++;
            }
          }
          tx.push(ib);
          boxarray.push(minarray);
          ib = 0;
        }
        this.quantity = tx;
        var indexs = 0;
        for (let i = 0; i < tx.length; i++) {
          for (var aa = 0; aa < answerBox.length; aa++) {
            if (Styledata[i] == answerBox[aa].Style) {
              indexs = indexs + 1;
              answerBox[aa]["indexs"] = indexs;
            } else {
              indexs = 0;
            }
          }
        }
        that.answerBox = answerBox;
        var quantitydata = [];
        for (let index = 0; index < Styledata.length; index++) {
          var add = {
            Style: Styledata[index],
            quantity: tx[index],
          };
          quantitydata.push(add);
        }
        this.quantitydata = quantitydata;
        localStorage.setItem("quantitydata", JSON.stringify(quantitydata));
        that.loadingShow = false; //加载结束
        this.timer = setInterval(this.startTimer, 1000); //考试用时
      }

      if (localStorage.getItem("answerLocation")) {
        this.swipeIndex = parseInt(localStorage.getItem("answerLocation"));
      }
      that.topicAnswerArray(); //创建储存答案数组
    },

    _getcs() {
      return new Promise((resolve, reject) => {
        var data = {
          configID: this.configID,
          ksbGuid: this.guid,
          TTP: "pc",
        };
        getcs(data).then((res) => {
          resolve(res);
        });
      });
    },

    //登录过期
    logginsBox() {
      Dialog.confirm({
        title: "您登录过期请重新登录",
        message: "确认重新登录吗？",
        confirmButtonColor: "#65b2ff",
        confirmButtonText: "确认", //改变确认按钮上显示的文字
        cancelButtonText: "取消", //改变取消按钮上显示的文字
      })
        .then(() => {
          that.$router.push({
            path: "/login",
          });
        })
        .catch(() => { });
    },
    //获取网络图片尺寸
    imgLoad(url, callback) {
      var img = new Image();
      img.src = url;
      if (img.complete) {
      } else {
        img.onload = function () {
          callback(img.width);
        };
      }
    },
    // 单选
    onAnswer: function (index, ItemName, Content, SelectedIndex, Type) {
      let TestItems = that.answerBox[index]; //找到当前题目
      //循环选项，选中为true，其他为false
      for (let i in TestItems.SelectedItems) {
        if (i == SelectedIndex) {
          TestItems.SelectedItems[i]["open"] = true;
        } else {
          TestItems.SelectedItems[i]["open"] = false;
        }
      }
      //再题目问题加入open 字段，true和状态切换

      // that.topicAnswer[that.swipeIndex]["index"] = index;
      //判断是否多选单选
      if (Type == "PDTEST") {
        that.topicAnswer[that.swipeIndex]["ItemName"] = Content;
      } else {
        that.topicAnswer[that.swipeIndex]["ItemName"] = ItemName;
      }
      this.$forceUpdate();
      this.selectInformation(that.answerBox, that.swipeIndex, that.topicAnswer);
      if (that.swipeItemIndex + 1 == that.answerBox.length) {
        this.$toast("没有题目了");
        return;
      }
      if (that.swipeIndex) {
      }
      localStorage.setItem("answerLocation", this.swipeIndex);
      //保存用户记录
      localStorage.setItem(
        "wjjachievementsBox",
        JSON.stringify(that.answerBox)
      );
      localStorage.setItem("wjjtopicAnswer", JSON.stringify(that.topicAnswer));
    },

    //多选
    onCheckboxAnswer: function (index, ItemName, SelectedIndex) {
      // that.topicAnswerArray(); //创建储存答案数组
      let TestItems = that.answerBox[index]; //找到当前题目
      TestItems.SelectedItems[SelectedIndex]["open"] =
        !TestItems.SelectedItems[SelectedIndex]["open"]; //再题目问题加入open 字段，true和状态切换

      if (TestItems.SelectedItems[SelectedIndex]["open"]) {
        //判断题目下选项true和false
        that.group.push(ItemName); //ItemName  把选中的选项储存起来
        //答案排序，优先级A,B,C,D...
        that.group.sort(function (s, t) {
          let a = s.toLowerCase();
          let b = t.toLowerCase();
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
      } else {
        //题目选项为false时，移除对应元素
        let indexs = that.group.indexOf(ItemName);
        if (indexs > -1) {
          that.group.splice(indexs, 1);
        }
        // that.group.splice(SelectedIndex, 1)
      }
      //返回答案
      // that.topicAnswer[that.swipeIndex]["index"] = index;
      that.topicAnswer[that.swipeIndex]["ItemName"] = that.group.join("");
      that.topicAnswer[that.swipeIndex]["group"] = that.group;
      this.$forceUpdate();
      localStorage.setItem("answerLocation", this.swipeIndex);
      this.selectInformation(that.answerBox, that.swipeIndex, that.topicAnswer);
      //保存用户记录
      localStorage.setItem(
        "wjjachievementsBox",
        JSON.stringify(that.answerBox)
      );
      localStorage.setItem("wjjtopicAnswer", JSON.stringify(that.topicAnswer));
    },
    //传用户选择信息到后台
    selectInformation(topicBox, currentanswer, topicAnswer) {
      // topicAnswer[currentanswer]["CptID"] = topicBox[currentanswer].CptID; //章节ID
      topicAnswer[currentanswer]["AllTestID"] =
        topicBox[currentanswer].AllTestID; //
      topicAnswer[currentanswer]["ChildTableID"] =
        topicBox[currentanswer].ChildTableID; //
      // topicAnswer[currentanswer]["Type"] = topicBox[currentanswer].Type; //

      if (
        topicBox[currentanswer].Type == "ATEST" ||
        topicBox[currentanswer].Type == "XTEST" ||
        topicBox[currentanswer].Type == "PDTEST"
      ) {
      } else if (topicBox[currentanswer].Type == "A3TEST") {
        topicAnswer[currentanswer]["A3TestItemID"] =
          topicBox[currentanswer].A3TestItemID; //
        topicAnswer[currentanswer]["A3TestID"] =
          topicBox[currentanswer].A3TestID; //
      } else {
        topicAnswer[currentanswer]["BTestID"] = topicBox[currentanswer].BTestID; //
        topicAnswer[currentanswer]["BTestItemID"] =
          topicBox[currentanswer].BTestItemID; //
      }
    },
    //创建数据储存选中答案
    topicAnswerArray() {
      var topicAnswer = new Array();
      if (that.topicAnswerTrue) {
        for (let i = 0; i < that.answerBox.length; i++) {
          var data = {
            ItemName: "",
          };
          that.topicAnswer.push(data);
          let JDTEST = {
            index: "",
          };
          that.jdtest.push(JDTEST); //简答题
        }
        that.topicAnswerTrue = false;
      }
      if (
        localStorage.getItem("wjjachievementsBox") &&
        localStorage.getItem("wjjtopicAnswer") &&
        JSON.parse(localStorage.getItem("wjjachievementsBox")).length != 0 &&
        JSON.parse(localStorage.getItem("wjjachievementsBox")).length != 0
      ) {
        that.answerBox = JSON.parse(localStorage.getItem("wjjachievementsBox"));
        that.topicAnswer = JSON.parse(localStorage.getItem("wjjtopicAnswer"));
        this.$forceUpdate();
      }
    },
    onChange: function (e) { },

    //对错答案
    answerContrast() {
      let answerBox = that.answerBox; //后台返回的题目数据
      var correctAnswer = new Array(); //正确答案
      var contrastAnswer = new Array(); //把对比正确答案存储
      var haveAnswer = new Array(); //把已答题目储存
      for (let i in answerBox) {
        correctAnswer.push(answerBox[i].Answer);
        if (correctAnswer[i] == that.topicAnswer[i].ItemName) {
          contrastAnswer.push(that.topicAnswer[i].ItemName);
        } else {
        }
        if (answerBox[i].Type == "JDTEST") {
          if (that.topicAnswer[i].ItemName != "") {
            contrastAnswer.push(that.topicAnswer[i].ItemName);
          }
        }
        //获取已答题数量
        if (that.topicAnswer[i].ItemName != "") {
          haveAnswer.push(that.topicAnswer[i].ItemName);
        }

        // let a =contrastAnswer.length / TestItems[i].Answer.length;
      }
      that.contrastAnswer = contrastAnswer; //正确答案
      that.correctAnswer = correctAnswer; //答对
      that.haveAnswer = haveAnswer; // 已答题目
      that.accuracy = (contrastAnswer.length / correctAnswer.length) * 100; //正确率
      //把Style存储起来，相同的Style剔除
      var arr2 = [];
      for (var i = 0; i < answerBox.length; i++) {
        arr2.push(answerBox[i].Style);
      }
      var StyleArray = arr2.filter(function (element, index, self) {
        return self.indexOf(element) === index;
      });

      that.achievementsBox = {
        contrastAnswer: contrastAnswer, //正确答案
        haveAnswer: haveAnswer, //已答题目
        accuracy: that.accuracy.toFixed(0), //正确率
        achievementsDate: that.achievementsDate, //答题时间
        answerBox: answerBox, //所有题目
        StyleArray: StyleArray, //题目类型
      };
    },

    //判断手滑动方向
    slideRheostat() {
      var mybody = document.getElementById("slideRheostat");
      var startX, startY, moveEndX, moveEndY, X, Y;
      mybody.addEventListener(
        "touchstart",
        function (e) {
          // e.preventDefault();
          startX = e.touches[0].pageX;
          startY = e.touches[0].pageY;
        },
        false
      );
      mybody.addEventListener("touchmove", function (e) {
        // e.preventDefault();
        moveEndX = e.changedTouches[0].pageX;
        moveEndY = e.changedTouches[0].pageY;
        X = moveEndX - startX;
        Y = moveEndY - startY;
        if (Math.abs(X) > Math.abs(Y) && X > 0) {
          // right
          // that.$toast("第一页1",index);
        } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
          // left
          // that.$toast("第一页2");
        }
      });
    },
    startTimer() {
      this.seconds += 1;
      if (this.seconds >= 60) {
        this.seconds = 0;
        this.minutes = this.minutes + 1;
      }

      if (this.minutes >= 60) {
        this.minutes = 0;
        this.hour = this.hour + 1;
      }
      that.achievementsDate =
        (this.minutes < 10 ? "0" + this.minutes : this.minutes) +
        ":" +
        (this.seconds < 10 ? "0" + this.seconds : this.seconds);
      // this.$refs.startTimer.innerHTML = that.achievementsDate;
    },
  },
};
</script>

<style scoped lang="less">
.yqbox {
  width: 80px;
}

.txzf {
  padding-left: 46px;
}

.answerimg {
  position: absolute;
  right: 70px;
}

.answerimg img {
  width: 24px;
  height: 24px;
}

.txdatas {
  margin-top: 35px;
  margin-bottom: 10px;
  font-size: 30px;
  color: #000000;
}

.stjj {
  text-align: center;
}

.van-button--normal {
  width: 200px;
  height: 70px;
  margin-top: 15px;
  background: #4c9cff;
  border: none;
  border-radius: 25px;
}

.stjj .van-button--normal {
  width: 300px;
  height: 70px;
  margin-top: 15px;
  background: #4c9cff;
  border: none;
  border-radius: 25px;
}

.diban {
  text-align: center;
  margin: 0 90px;
  // display: flex;
  // justify-content: space-between;
  line-height: 85px;
  margin: 0 auto;
}

.diban .van-button {
  margin: 0 20px;
}

#slideRheostat/deep/.van-swipe-item {
  height: calc(100vh - 50px);
  overflow: scroll;
}

.kmj {
  height: calc(100vh - 200px);
  overflow: scroll;
  padding-bottom: 100px;
}

.NewcardContent {
  height: calc(100vh - 200px);
  overflow: scroll;
  padding-bottom: 100px;
  margin: 0 34px;
}

.titelbox {
  height: 100px;
  margin-bottom: 28px;
  line-height: 100px;
  background: #ffffff;
  box-shadow: 9px 9px 18px 9px rgba(239, 239, 239, 0.8);
  // background: #ccc;
  padding: 0 33px;
  color: #1a1a1a;
}

.van-icon {
  top: 5px;
  color: #b4b4b4;
}

.nub {
  color: #ffbe6a;
}

.titelbox-ico {
  float: left;
  padding-right: 240px;
  font-size: 50px;
}

.titelbox-tm {
  float: left;
  font-size: 30px;
  padding-left: 10px;
  font-size: 30px;
  color: #000001;
  font-weight: 400;
}

.titelbox-tk {
  float: right;
  font-size: 30px;
}

.titelbox-tk img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 34px;
  right: 100px;
}

.questiontypes {
  font-size: 30px;
  padding: 0 34px;
  padding-top: 30px;
}

.tijiao_newbtn-box {
  width: 150px;
  font-size: 30px;
  border-radius: 50px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  margin: 100px auto;
}

.tijiao_newbtn {
  width: 150px;
  padding: 10px 5px;
  font-size: 30px;
  border-radius: 50px;
  color: #fff;
  background: #5bb8ff;
}

.tijiao_newbtn-span {
  text-align: center;
  color: #000000;
}

.textareas-box {
  margin: 10px auto;
  width: 80%;
  height: 200px;
}

.textareas {
  height: 210px;
  border: 1px solid #000000;
}

#slideRheostat {
  // height: 100vh;
  // overflow: hidden;
  background: #ccc;
}

.nowNoan {
  background: #ffd9ab !important;
  color: #fd903a !important;
}

//错颜色
.wrongColor {
  color: #ee7674 !important;
}

.wrongBg {
  background: #ee7674 !important;
  color: #ffffff !important;
}

.tk-d {
  background: #6dd3b0 !important;
  color: #ffffff !important;
}

.tk-c {
  background: #ee7674 !important;
  color: #ffffff !important;
}

////对
.answerColor {
  color: #6dd3b0 !important;
}

.tabBar-bottom {
  color: #999;
}

.faceColors {
  color: #6dd3b0 !important;
}

.correctBg {
  background: #6dd3b0;
  color: #ffffff !important;
}

.line {
  display: inline-block;
  height: 30px;
  width: 5px;
  background: #5bb8fe;
}

.main {
  background: #ffffff;
  // overflow: scroll;
  // height: 100%;
}

.pitch {
  background: #ffefd7;
  border: 1px solid #ffefd7 !important;
  color: #ffb133 !important;
}

.pitchs {
  color: #ffb133 !important;
}

.tag {
  color: #5bb8fe;
  margin: 0px 2px;
}

.navigation {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: rgba(91, 184, 255, 1);
  /* border-bottom: 1px solid #EEEEEE; */
  position: relative;
}

.arrowsLeft {
  display: flex;
  align-items: center;
  position: absolute;
  font-size: 30px;
  left: 20px;
  top: 50px;
  margin-top: -18px;
}

.navigationTitle {
  font-size: 30px;
}

// Explain
.Explain {
  background: #ffffff;
  padding: 30px;
  margin-top: 20px;
  display: flex;
  color: #888888;
  justify-content: space-between;
  box-sizing: border-box;
}

.Explain-answer {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.Explain-answer ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.analysis-details {
  color: #888888;
}

.Explain-answer ul li {}

.Explain-answer ul li:nth-child(2) {
  margin-left: 30px;
  font-size: 30px;
}

.analysis-left {
  display: flex;
  flex-direction: row;
}

.Explain-right-img {
  width: 190px !important;
  height: 150px !important;
}

.Explain-answer ul li:nth-child(3) {
  width: 120px;
  height: 50px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 20px;
  border: 1px solid #cccccc;
}

li {
  list-style: none;
}

.analysis {
  border-top: 1px solid #cccccc;
  padding: 0px 30px;
  box-sizing: border-box;
  color: #888888;
  font-size: 30px;
  text-align: left;
  padding-top: 20px;
  background: #ffffff;
}

.analysis-text {
  margin-left: 20px;
}

/*  */

.tabBar {
  width: 100%;
  height: 100px;
  position: fixed;
  left: 0px;
  bottom: 0px;
  border-top: 1px solid #eeeeee;
  background: #ffffff;
}

.tabBar ul {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
}

.tabBar ul li {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.tabBar li {
  display: flex;
  flex-direction: column;
}

/*  */
.answer-title {
  padding: 38px 34px;
  font-size: 28px;
  color: #454444;
  font-weight: 400;
  word-break: break-all;
  box-sizing: border-box;
  padding-bottom: 20px;
}

// .answer-box/deep/.van-radio__label { //穿透
//   height: 90px;
//   font-size: 30px;
// }
.van-radio {
  margin-top: 10px;
  text-align: left;
  color: #888888;
}

.checkedBox {
  font-size: 29px;
  padding: 0 10px;
  box-sizing: border-box;
  color: #454444;
  margin: 30px 34px;
  // box-shadow: 1px 1px 10px 1px rgba(239, 239, 239, 0.8);
  padding-right: 100px;
}

.checkedBox-left {
  width: 80px;
  height: 80px;
  font-size: 32px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-left: 30px;
  border: 1px solid #cccccc;
  color: #454444;
}

.checkedBox-leftb {
  width: 80px;
  height: 80px;
  font-size: 32px;

  display: flex;
  justify-content: center;
  align-items: center;
  // padding-left: 30px;
  border: 1px solid #cccccc;
  color: #454444;
}

.checkedBox-right {
  margin-left: 30px;
}

.selectAnswer {
  font-size: 30px;
  margin-top: 5px;
  text-align: left;
  margin-left: 50px;
}

.accuracy {
  font-size: 30px;
  margin-top: 5px;
  margin-left: 50px;
}

.examine {
  width: 180px;
  height: 60px;
  border-radius: 10px;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  margin: 0px auto;
  margin-top: 10px;
  background: #5bb8fe;
}

// 题卡
.mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

.mask-main {
  position: fixed;
  z-index: 1000;
  width: 100%;
  /*  max-width: 300px;
	  min-height: 300px; */
  bottom: 0;
  left: 0%;
  // border-radius: 20px 20px 0px 0px;
  /* margin-left: -25%; */
  background-color: #ffffff;

  transition: height 2s;
  -moz-transition: height 2s;
  /* Firefox 4 */
  -webkit-transition: height 2s;
  /* Safari 和 Chrome */
  -o-transition: height 2s;
  /* Opera */
  box-sizing: border-box;
}

.card ul {
  display: flex;
  flex-direction: row;
}

.card ul li {
  display: flex;
  width: 0.8rem;
  height: 0.8rem;
  margin-left: 0.2rem;
  align-items: center;
  justify-content: center;
  background: #cccccc;
}

.exercises-top {
  width: 100%;
  padding: 10px 0px;
  background: #5bb8fe;
  box-sizing: border-box;
}

.navigations {
  width: 100%;
  height: 100px;
  display: flex;
  /* justify-content: space-between; */
  align-items: flex-end;
  padding: 10px 30px;
  font-size: 30px;
  color: #ffffff;
  box-sizing: border-box;
}

.arrowsLefts {
  flex: 1;
  text-align: left;
  font-size: 30px;
}

.title-tk {
  display: flex;
  flex: 1;
  justify-content: center;
}

.buy-s {
  display: flex;
  flex: 1;
}

.buy {
  padding: 5px 15px;
  border-radius: 5px;
  border: 1px solid #ffffff;
  font-size: 25px;
  margin-left: 50px;
}

.score_content {
  position: relative;
  width: 63%;
  font-size: 30px;
  margin-left: 20px;
  border-radius: 4px;
  background: #3ba3f3;
  color: #fff;
  padding: 10px;
}

.score_content::after {
  border-right: 7px solid #3ba3f3;
}

.score_content::after {
  border-right: 7px solid #3ba3f3;
}

.score_content:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  left: -7px;
  top: 50%;
  margin-top: -10px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-right: 7px solid #3ca1f7;
}

.score_content span {
  color: #fbe074;
  font-size: 30px;
  padding: 2px;
}

.sheetChart {
  display: flex;
  flex-direction: row;
  margin: 30px 30px;
  // margin: 20px 0px;
  box-sizing: border-box;
}

.reportSheet-box {
  display: flex;
  justify-content: space-around;
  font-size: 30px;
}

.bottomTab {
  width: 100%;
  display: flex;
  position: fixed;
  left: 0px;
  bottom: 0px;
  font-size: 30px;
}

.Tableft {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 15px 0px;
  color: #757575;
}

.Tabc {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  background: #5bb8ff;
  padding: 15px 0px;
  color: #ffffff;
}

.Tabright {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 15px 0px;
  color: #757575;
}

.NewcardContent-ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.NewcardContent-li {
  display: flex;
  width: 1.1333333rem;
  height: 1.1333333rem;
  border-radius: 80px;
  margin: 0px 25px;
  font-size: 30px;
  margin-top: 30px;
  align-items: center;
  justify-content: center;
  color: #454444;
  background: #eeeeee;
}

body {
  padding: 0;
  margin: 0;
}

.container {
  height: calc(100vh - 50px);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  // overflow: scroll;
  /* margin: 100px 0; */
}

.header {
  width: 100%;
  height: 100px;
  background-color: #e77c8e;
  position: fixed;
  z-index: 2;
}

.main {
  width: 100%;
  flex: 1;
  // background-color: #2bae85;
  margin: 100px 0;
}

.footer {
  width: 100%;
  height: 100px;
  // background-color: #7a7374;
  position: fixed;
  bottom: 0;
  box-shadow: 9px 9px 18px 9px rgba(239, 239, 239, 0.8);
  background: #fff;
  z-index: 2;
}

//隐藏滚动条
::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

#slideRheostat /deep/.van-dialog__header {
  padding: 0rpx 30px !important;
  box-sizing: border-box;
}

.className {
  padding: 30px;
}

.spinner {
  position: absolute;
  left: 50%;
  top: 30%;
  margin-left: -6vw;
  z-index: 2;
}
</style>
